(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    var grid      = document.querySelector('.job-grid');
    var countEl   = document.querySelector('.search-form__count');
    var ajaxUrl   = (typeof montrougeAjax !== 'undefined') ? montrougeAjax.url : '/wp-admin/admin-ajax.php';

    // ─── AJAX filter ─────────────────────────────────────────────────────────
    function buildParams(form) {
      var fd     = new FormData(form);
      var params = new URLSearchParams();
      fd.forEach(function (val, key) { params.append(key, val); });
      params.set('action', 'montrouge_filter_jobs');
      return params;
    }

    function doFilter(form) {
      var params = buildParams(form);

      // Mettre à jour l'URL sans rechargement
      history.pushState(null, '', '?' + params.toString().replace(/&?action=[^&]*/g, '').replace(/^\?/, ''));

      if (grid) grid.style.opacity = '0.5';

      fetch(ajaxUrl + '?' + params.toString())
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res.success) return;
          if (grid)    grid.innerHTML  = res.data.html;
          if (countEl) countEl.innerHTML = '<strong>' + res.data.count + '</strong> ' + res.data.countLabel;
          if (grid)    grid.style.opacity = '1';
          bindCardLinks();
        });
    }

    // ─── Multiselect ─────────────────────────────────────────────────────────
    document.querySelectorAll('.multiselect').forEach(function (ms) {
      var trigger      = ms.querySelector('.multiselect__trigger');
      var dropdown     = ms.querySelector('.multiselect__dropdown');
      var labelEl      = ms.querySelector('.multiselect__label');
      var defaultLabel = ms.dataset.label || 'Sélectionner';

      function updateLabel() {
        var checked = ms.querySelectorAll('input[type="checkbox"]:checked');
        if (checked.length === 0) {
          labelEl.textContent = defaultLabel;
        } else {
          var noun = ms.dataset.noun || 'élément';
          labelEl.textContent = checked.length + ' ' + noun + (checked.length > 1 ? 's' : '');
        }
        ms.querySelectorAll('.multiselect__option').forEach(function (opt) {
          opt.classList.toggle('is-checked', opt.querySelector('input').checked);
        });
      }

      trigger.addEventListener('click', function () {
        var isOpen = dropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      });

      ms.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          updateLabel();
          doFilter(ms.closest('form'));
        });
      });

      document.addEventListener('click', function (e) {
        if (!ms.contains(e.target)) {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // ─── Interception de la soumission du formulaire ──────────────────────────
    var searchForm = document.querySelector('.search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        doFilter(searchForm);
      });
    }

    // ─── Keyword avec debounce ────────────────────────────────────────────────
    var keywordInput = document.querySelector('.search-form input[name="keyword"]');
    if (keywordInput) {
      var keywordTimer;
      keywordInput.addEventListener('input', function () {
        clearTimeout(keywordTimer);
        keywordTimer = setTimeout(function () {
          doFilter(keywordInput.closest('form'));
        }, 500);
      });
    }

    // ─── Persistance des filtres de recherche ─────────────────────────────────
    function bindCardLinks() {
      document.querySelectorAll('.job-card__link, .job-card__arrow').forEach(function (link) {
        link.addEventListener('click', function () {
          sessionStorage.setItem('utopik_search', window.location.search);
        });
      });
    }
    bindCardLinks();

    // ─── Restauration bfcache ─────────────────────────────────────────────────
    // Le navigateur peut restaurer la page depuis le bfcache dans un état
    // intermédiaire (grille vide ou en cours de chargement). On recharge le
    // filtre depuis les paramètres de l'URL courante.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && grid) {
        var params = new URLSearchParams(window.location.search);
        params.set('action', 'montrouge_filter_jobs');
        grid.style.opacity = '0.5';
        fetch(ajaxUrl + '?' + params.toString())
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res.success) return;
            grid.innerHTML = res.data.html;
            if (countEl) countEl.innerHTML = '<strong>' + res.data.count + '</strong> ' + res.data.countLabel;
            grid.style.opacity = '1';
            bindCardLinks();
          });
      }
    });

    // ─── Copier l'URL (page single) ───────────────────────────────────────────
    var copyBtn = document.querySelector('.single-offre__share-btn--copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url       = copyBtn.dataset.url;
        var iconCopy  = copyBtn.querySelector('.share-icon-copy');
        var iconCheck = copyBtn.querySelector('.share-icon-check');

        function showFeedback() {
          iconCopy.style.display  = 'none';
          iconCheck.style.display = '';
          setTimeout(function () {
            iconCopy.style.display  = '';
            iconCheck.style.display = 'none';
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showFeedback);
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
          document.body.appendChild(ta);
          ta.focus(); ta.select();
          try { document.execCommand('copy'); showFeedback(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    }

    // Restaure les paramètres sur le bouton "Retour aux offres" (page single)
    var backBtn = document.querySelector('.btn-back');
    if (backBtn) {
      var savedSearch = sessionStorage.getItem('utopik_search');
      if (savedSearch) {
        var baseUrl = backBtn.href.split('?')[0].replace(/#.*$/, '');
        backBtn.href = baseUrl + savedSearch + '#offres';
      }
    }

    // ─── Burger menu mobile ───────────────────────────────────────────────────
    var burger = document.querySelector('.site-header__burger');
    var nav    = document.getElementById('site-nav');

    if (burger && nav) {
      burger.addEventListener('click', function () {
        var isOpen = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', isOpen);
        burger.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
      });

      // Fermer si clic en dehors
      document.addEventListener('click', function (e) {
        if (!burger.contains(e.target) && !nav.contains(e.target)) {
          nav.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
          burger.setAttribute('aria-label', 'Ouvrir le menu');
        }
      });
    }

    // ─── CTA Dropdowns (header + footer) ─────────────────────────────────────
    document.querySelectorAll('.site-header__cta-wrap, .site-footer__cta-wrap').forEach(function (wrap) {
      var btn  = wrap.querySelector('[aria-haspopup]');
      var menu = wrap.querySelector('[class$="__cta-menu"]');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = menu.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen);
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          menu.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });

    var scrollIndicator = document.querySelector('.hero__scroll-indicator');
    var offresSection = document.querySelector('.offres');

    if (scrollIndicator && offresSection) {
      scrollIndicator.addEventListener('click', function () {
        offresSection.scrollIntoView({ behavior: 'smooth' });
      });
    }
  });
})();
